import React from 'react'
import { CustomButton } from 'components/ui'
import { OptionsItem, SelectInput } from 'components/ui/Forms/SelectInput'
import TextInput from 'components/ui/Forms/TextInput'
import { useFormik } from 'formik'
import { infoProjectValidation } from 'lib/validation/yupValidation'
import DatesInputsCalendar from '../EditProyecto.jsx/ConfigProyecto/DatesInputsCalendar'
import { useCreateFormProject } from 'lib/react-query/queriesProject'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'

const statusS_PROJECT = ['Planificación', 'Oferta', 'Abierto', 'Completado']
const typeCodeOptions = ['Jit', 'Cliente']

const FormCreateProyecto = ({ imageFile }) => {
  const { user } = useAuth0()
  const { mutateAsync } = useCreateFormProject()
  const navigate = useNavigate()

  const { handleChange, values, errors, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: {
        code: '',
        name: '',
        description: '',
        status: 'Planificación',
        startAt: new Date(),
        finishAt: '',
        typeCode: 'Jit',
        hubId: '',
        item: '',
      },

      onSubmit: async values => {
        values.user = [user.sub]
        try {
          await mutateAsync({
            body: values,
            image: imageFile,
          })
          navigate('/')
        } catch (error) {}
      },
      validationSchema: infoProjectValidation,
    })

  const isButtonFormDisabled = () => {
    if (
      !values.code.trim() ||
      !values.name.trim() ||
      !values.typeCode.trim() ||
      !values.hubId.trim()
    ) {
      return true
    }

    if (values.status === 'Completado' && !values.finishAt) {
      return true
    }
    if (new Date(values.finishAt) < new Date(values.startAt)) {
      return true
    }

    return false
  }

  return (
    <form
      onSubmit={handleSubmit}
      noValidate
      className="form-main-info-proyecto-container"
    >
      <div className="calendars-inputs-container">
        <div className="calendar-input-container">
          <TextInput
            label={
              <span className="label-class">
                Código <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="code"
            value={values.code}
            onChange={handleChange}
          />
          {errors.code && <p className="error-form">{errors.code}</p>}
        </div>
        <div className="calendar-input-container">
          <SelectInput
            label={
              <span className="label-class">
                Tipo Código <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="typeCode"
            value={values.typeCode}
            onChange={handleChange}
          >
            {typeCodeOptions.map((option, i) => (
              <OptionsItem key={i} name="typeCode" value={option}>
                {option}
              </OptionsItem>
            ))}
          </SelectInput>
          {errors.typeCode && <p className="error-form">{errors.typeCode}</p>}
        </div>
      </div>

      <div>
        <TextInput
          label={
            <span className="label-class">
              Nombre <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        {errors.name && <p className="error-form">{errors.name}</p>}
      </div>

      <div>
        <TextInput
          label={<span className="label-class">Descripción</span>}
          name="description"
          value={values.description}
          onChange={handleChange}
        />
        {errors.description && (
          <p className="error-form">{errors.description}</p>
        )}
      </div>

      <div>
        <SelectInput
          label={<span className="label-class">Estado</span>}
          value={values.status}
          onChange={handleChange}
          name="status"
        >
          {statusS_PROJECT.map((status, i) => (
            <OptionsItem key={i} name="status" value={status}>
              {status}
            </OptionsItem>
          ))}
        </SelectInput>
        {errors.status && <p className="error-form">{errors.status}</p>}
      </div>

      <div className="calendars-inputs-container">
        <div className="calendar-input-container">
          <DatesInputsCalendar
            label={<span className="label-class">Fecha inicio</span>}
            name="startAt"
            date={values.startAt || null}
            handleChange={day => setFieldValue('startAt', day)}
          />
        </div>
        <div className="calendar-input-container">
          <DatesInputsCalendar
            label={<span className="label-class">Fecha fin</span>}
            name="finishAt"
            date={values.finishAt || null}
            handleChange={day => setFieldValue('finishAt', day)}
            disabled={values.status !== 'Completado'}
          />
          {errors.finishAt && <p className="error-form">{errors.finishAt}</p>}
        </div>
      </div>

      <div>
        <TextInput
          label={
            <span className="label-class">
              Item <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="item"
          value={values.item}
          onChange={handleChange}
        />
        {errors.item && <p className="error-form">{errors.item}</p>}
      </div>

      <div>
        <TextInput
          label={
            <span className="label-class">
              Hub Id <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="hubId"
          value={values.hubId}
          onChange={handleChange}
        />
        {errors.hubId && <p className="error-form">{errors.hubId}</p>}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <CustomButton type="submit" disabled={isButtonFormDisabled()}>
          <p style={{ fontSize: '1.2rem' }}>Guardar</p>
        </CustomButton>
      </div>
    </form>
  )
}

export default FormCreateProyecto
